import rhinoAuth from './auth/auth.module';
import rhinoBlue from './blue/blue.module';
import rhinoClient from './client/client.module';
import rhinoDebug from './debug/debug.module';
import rhinoHttp from './http/http.module';
import rhinoRecord from './record/record.module';
import rhinoRegistry from './registry/registry.module';

import rhinoConfig from './core.config';
import rhinoRun from './core.run';

/**
 * @ngdoc overview
 * @name rhino.core
 * @description The core Rhino module, which includes all of the central features of Rhino including authentication, the Rhino Registry,
 * the Rhino HTTP service, and Rhino Records.
 */
export default angular.module('rhino.core', [
  'angulartics.google.analytics', // depend on angulartics google analytics so that all apps get this plugged in automatically
  'ngCookies',
  rhinoAuth,
  rhinoBlue,
  rhinoClient,
  rhinoDebug,
  rhinoHttp,
  rhinoRecord,
  rhinoRegistry,
])
  .config(rhinoConfig)
  .run(rhinoRun)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/core.module.js